import { IInternalAuthentication } from '@edgebox/api-rest-client';
import React from 'react';

// create the context
export const AuthenticationContext: any = React.createContext<IInternalAuthentication | null>(null);
